import React, { useState, useEffect, useCallback, useRef } from 'react';
import { format, parse } from 'date-fns';
import DateRangePicker from '@/components/ui/DateRangePicker';
import PagesWrapper from '@/components/ui/shared/PagesWrapper';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Search, SlidersHorizontal, X, Loader2 } from 'lucide-react';
import ListChartWidget from '../ListChartWidget';
import ColumnPieChart from '../ColumnPieChart';
import FilterTagCom from '../FilterTag';
import { userService } from '../../_services';
import { Redirect, NavLink } from "react-router-dom";
import { safeParseDate } from '@/lib/utils';

function Pharmacies({ AnalyticData, handeChangefilter }) {
    // Initialize dates
    const getInitialDates = () => {
        const defaultStartDate = new Date();
        defaultStartDate.setDate(defaultStartDate.getDate() - 30);
        const defaultEndDate = new Date();
        
        const storedStartDate = localStorage.getItem('User_Start_Date');
        const storedEndDate = localStorage.getItem('User_End_Date');
        
        const startdate = (storedStartDate && storedStartDate !== "" && storedStartDate !== "null")
            ? safeParseDate(storedStartDate, defaultStartDate)
            : defaultStartDate;
        const enddate = (storedEndDate && storedEndDate !== "" && storedEndDate !== "null")
            ? safeParseDate(storedEndDate, defaultEndDate)
            : defaultEndDate;
            
        return {
            startDate: startdate,
            endDate: enddate
        };
    };

    const initialDates = getInitialDates();
    const [startDate, setStartDate] = useState(initialDates.startDate);
    const [endDate, setEndDate] = useState(initialDates.endDate);
    const [graphData, setGraphData] = useState([]);
    const [scrollArray, setScrollArray] = useState({});
    const [dashboardName, setDashboardName] = useState('');
    const [FilterTagList, setFilterTagList] = useState(() => {
        try {
            const stored = localStorage.getItem('Advance_Filter');
            return stored && stored !== "null" && stored !== "{}" ? stored : '';
        } catch {
            return '';
        }
    });
    const [searchDisplay, setSearchDisplay] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [userFilterList, setUserFilterList] = useState([]);
    const searchInputRef = useRef(null);
    const [userdata] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch {
            return null;
        }
    });

    // Calculate roletype, rolename, wh_Id
    const getRoleInfo = useCallback(() => {
        if (!userdata) return { roletype: '', rolename: '', wh_Id: 0 };
        
        let _roletype = '';
        let _rolename = '';
        let _wh_Id = 0;
        
        try {
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenelllllll") {
                _roletype = "avdistributor";
                _rolename = userdata.email;
                _wh_Id = userdata.wholesaler_Id;
            } else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenelllll") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            } else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
        } catch (error) {
        }
        
        return { roletype: _roletype, rolename: _rolename, wh_Id: _wh_Id };
    }, [userdata]);

    const roleInfo = getRoleInfo();

    const changeData = useCallback((dateChanged, stdate, endate) => {
        let startDateObj = '';
        let endDateObj = '';
        if (dateChanged == undefined) {
            startDateObj = startDate;
            endDateObj = endDate;
        } else {
            startDateObj = stdate;
            endDateObj = endate;
        }

        let AdFilterJson = '';
        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'));
            if (AdFilterJson != null && AdFilterJson != '' && AdFilterJson != undefined && AdFilterJson != "null") {
                setFilterTagList(JSON.stringify(AdFilterJson));
            } else {
                setFilterTagList('');
            }
        } catch (error) {
            setFilterTagList('');
        }
        
        const startDateFormatted = format(safeParseDate(startDateObj), "yyyyMMdd");
        const endDateFormatted = format(safeParseDate(endDateObj), "yyyyMMdd");
        const changedStartDate = format(parse(startDateFormatted, "yyyyMMdd", new Date()), "MM/dd/yyyy");
        const changedEndDate = format(parse(endDateFormatted, "yyyyMMdd", new Date()), "MM/dd/yyyy");
        setStartDate(changedStartDate);
        setEndDate(changedEndDate);
        
        const Table_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + userdata["wholesaler_Id"] + "\"}";
        const PatientSavings_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + userdata["wholesaler_Id"] + "\"}";
        const PharmacyChain_PaidClaims_PostData_RequestJson = "{\"wname\"" + ":\"" + userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + userdata["wholesaler_Id"] + "\"}";
        const APIBaseURL = '/api/admin';
        
        const graphDataArray = [
            {
                        url: APIBaseURL + "/pharmacy_transaction_new",
                        type: "List",
                        title: "Transactions by Pharmacy",
                        Subtitle: "Number of transactions at each pharmacy",
                        ColorCode: "#ffba10",
                        XlabelString: "",
                        YlabelString: "",
                        id: "WPharmacyTransaction1",
                        RequestJson: Table_Pharmacy_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL + "/patientsavings_new",
                        type: "List",
                        title: "Patient Savings by Pharmacy",
                        Subtitle: "Patient savings in $ at each pharmacy",
                        ColorCode: "#ffba10",
                        XlabelString: "",
                        YlabelString: "",
                        id: "WPatientSavingTransaction",
                        RequestJson: PatientSavings_Pharmacy_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL + "/pharmacychainpaidclaims",
                        type: "Column_Pie",
                        title: "Paid Claims by Pharmacy Chain",
                        Subtitle: "Paid claims broken down by Pharmacy Chain",
                        XlabelString: "States",
                        YlabelString: "Paid Claims",
                        ColorCode: "#ffba10",
                        DataType: "Pharmacy Chain",
                        id: "PharmacyChainPaidClaimsAdmin",
                        RequestJson: PharmacyChain_PaidClaims_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    }
        ];
        
        setDashboardName('');
        setGraphData(graphDataArray);
    }, [startDate, endDate, userdata]);

    const handleCalendar = useCallback((e, picker) => {
        const changedStartDate = format(safeParseDate(picker.startDate), "MM/dd/yyyy");
        const changedEndDate = format(safeParseDate(picker.endDate), "MM/dd/yyyy");
        localStorage.setItem('User_Start_Date', changedStartDate);
        localStorage.setItem('User_End_Date', changedEndDate);
        changeData(true, changedStartDate, changedEndDate);
    }, [changeData]);

    const searchWholesalers = useCallback(async (text) => {
        if (text.length < 2) {
            setSearchDisplay([]);
            setShowSearchResults(false);
            setSearchLoading(false);
            return;
        }
        
        setSearchLoading(true);
        
        try {
            const response = await fetch('/api/Filter/SearchOnTypeText', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    text,
                    roletype: roleInfo.roletype || '',
                    rolename: roleInfo.rolename || '',
                    whname: roleInfo.wh_Id ? roleInfo.wh_Id.toString() : ''
                })
            });
            const data = await response.json();
            setSearchDisplay(data || []);
            setShowSearchResults(true);
            setSearchLoading(false);
        } catch (error) {

            setSearchDisplay([]);
            setSearchLoading(false);
        }
    }, [roleInfo]);

    const handleSearchChange = useCallback((e) => {
        const value = e.target.value;
        setSearchValue(value);
        searchWholesalers(value);
    }, [searchWholesalers]);

    const handleSearchFocus = useCallback(() => {
        if (searchValue.length >= 2 && searchDisplay.length > 0) {
            setShowSearchResults(true);
        }
    }, [searchValue, searchDisplay]);

    const handleSearchItemClick = useCallback((item) => {
        try {
            // SearchOnTypeText returns ctype, cvalue structure
            if (!item || !item.ctype || !item.cvalue) {

                return;
            }
            
            let Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter')) || {};
            const filterKey = item.ctype; // Use the ctype from the API response
            
            if (Created_Advance_Filter[filterKey]) {
                if (!Created_Advance_Filter[filterKey].includes(item.cvalue)) {
                    Created_Advance_Filter[filterKey].push(item.cvalue);
                }
            } else {
                Created_Advance_Filter[filterKey] = [item.cvalue];
            }
            
            localStorage.setItem('Advance_Filter', JSON.stringify(Created_Advance_Filter));
            localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
            localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
            localStorage.setItem('Updated_Filter_Status', 'true');
            
            setSearchValue('');
            setShowSearchResults(false);
            changeData();
        } catch (error) {

        }
    }, [changeData]);

    const handleRemoveTag = useCallback((key, value) => {
        let filters = JSON.parse(localStorage.getItem('Advance_Filter')) || {};
        if (filters[key]) {
            filters[key] = filters[key].filter(v => v !== value);
            if (filters[key].length === 0) delete filters[key];
        }
        const newFilter = Object.keys(filters).length === 0 ? null : JSON.stringify(filters);
        localStorage.setItem('Advance_Filter', newFilter);
        localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
        localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
        localStorage.setItem('Updated_Filter_Status', 'true');
        // When removing PCN:HD (PBM:HD), mark Updated_HD_Type as 'totalpaid' so TopMenu
        // doesn't re-add the filter when navigating back to the transaction dashboard.
        if (key === 'PBM' && value === 'HD') {
            const currentHDType = localStorage.getItem('Updated_HD_Type');
            localStorage.setItem('Prev_HD_Type', currentHDType);
            localStorage.setItem('Updated_HD_Type', 'totalpaid');
        }
        changeData();
    }, [changeData]);

    const handleResetButton = useCallback(() => {
        // Always save prev HD type and reset to 'totalpaid' — resetting removes the
        // PBM:HD default filter, so TopMenu must not restore it on navigation.
        const currentHDType = localStorage.getItem('Updated_HD_Type');
        localStorage.setItem('Prev_HD_Type', currentHDType);
        localStorage.setItem('Updated_HD_Type', 'totalpaid');
        localStorage.setItem('Advance_Filter', null);
        localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
        localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
        localStorage.setItem('Updated_Filter_Status', 'true');
        changeData();
    }, [changeData]);

    const getTagTypeFullName = (key) => {
        const mapping = {
            'PBM': 'PCN',
            'PhBin': 'BIN',
            'DistributorName': 'Distributor Name',
            'PhCity': 'Pharmacy City',
            'PrCity': 'Prescriber City',
            'PhState': 'Pharmacy State',
            'PrState': 'Prescriber State',
            'PhZip': 'Pharmacy ZIP',
            'PrZip': 'Prescriber ZIP',
            'PharmacyName': 'Pharmacy Name',
            'GroupNumber': 'Group Number',
            'WholesalerName': 'Wholesaler Name',
            'DrugName': 'Drug Name',
            'Prescriber': 'Prescriber Name',
            'PrescriberName': 'Prescriber Name',
            'Override': 'Override',
            'PhGPrefix': 'Group Prefix',
            'Group Prefix': 'Group Prefix',
            'WebCampaign': 'Web Campaign',
            'BrokerName': 'Broker Name',
            'EmailCampaign': 'Email Campaign',
            'Other': 'Other Name',
            'SMSCampaign': 'SMS Campaign',
            'MailCampaign': 'Mail Campaign',
            'Pharmacy Chain': 'Pharmacy Chain'
        };
        return mapping[key] || key;
    };

    const applyUserFilter = useCallback((item) => {
        try {
            const parsedFilter = JSON.parse(item.filterJson);
            const rawDataset = parsedFilter.dataset;
            const filterDataset = (rawDataset && typeof rawDataset === 'object' && Object.keys(rawDataset).length > 0)
                ? JSON.stringify(rawDataset)
                : null;
            
            localStorage.setItem('Advance_Filter', filterDataset);
            localStorage.setItem('Updated_AdFilter_Status', filterDataset);
            localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
            
            changeData();
        } catch (error) {

        }
    }, [changeData]);

    const loadUserFilters = useCallback(() => {
        try {
            const dashboardId = userdata?.dList?.[0]?.dashboardId || '';
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ FilterName: '', FilterJson: '', DashboardId: dashboardId })
            };
            fetch('/api/Filter/GetUserAdFilter', requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data && data[0] && data[0].filterset) {
                        setUserFilterList(data[0].filterset);
                    }
                })
                .catch(error => {});
        } catch (error) {

        }
    }, [userdata]);

    const handlechangea = useCallback((e) => {
        if (e && e.heading && e.value) {
            // Validate heading is not undefined or invalid
            if (e.heading === 'undefined' || !e.heading) {
                return;
            }
            
            try {
                let Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter')) || {};
                
                if (Created_Advance_Filter[e.heading]) {
                    if (!Created_Advance_Filter[e.heading].includes(e.value)) {
                        Created_Advance_Filter[e.heading].push(e.value);
                    }
                } else {
                    Created_Advance_Filter[e.heading] = [e.value];
                }
                
                localStorage.setItem('Advance_Filter', JSON.stringify(Created_Advance_Filter));
                localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                
            } catch (error) {
                console.error('Error saving filter:', error);
            }
        }
        
        changeData();
        if (handeChangefilter) {
            handeChangefilter(e);
        }
    }, [changeData, handeChangefilter]);

    useEffect(() => {
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        changeData();
        loadUserFilters();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchInputRef.current && !searchInputRef.current.contains(event.target)) {
                setShowSearchResults(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Auth checks
    const userType = userService.Get_User_Type();
    if (userService.Check_LoggedIn_Status() === 'Login') {
        return <Redirect to="/login" />;
    }
    if (['distributor', 'subadmin', 'wholesaler'].includes(userType?.toLowerCase())) {
        return <Redirect to='/pageNotFound' />;
    }

                            return (
        <PagesWrapper>
            <div className="flex flex-col gap-4">
                <div className="flex items-center">
                    <h1 className="text-2xl font-semibold text-foreground">
                        Pharmacies
                    </h1>
                </div>

                <Card>
                    <CardContent className="analytics-card-content">
                        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-4">
                            <DateRangePicker
                                className="w-full lg:w-[320px] h-10 shrink-0"
                                initialSettings={{
                                    startDate: format(startDate, "MM/dd/yyyy"),
                                    endDate: format(endDate, "MM/dd/yyyy"),
                                    maxDate: new Date(),
                                    locale: {
                                        format: 'MM/DD/YYYY'
                                    }
                                }}
                                onApply={handleCalendar}>
                                <div className="flex items-center gap-0 w-full lg:w-[320px] rounded-md overflow-hidden border border-input bg-card hover:shadow-sm transition-shadow h-10">
                                    <div className="flex items-center gap-1 px-3 flex-1">
                                        <span className="text-sm text-muted-foreground whitespace-nowrap">From</span>
                                        <Input
                                            type="text"
                                            className="bg-transparent text-sm cursor-pointer w-full !border-0 outline-none h-auto p-0 rounded-none"
                                            value={format(startDate, "MM/dd/yyyy")}
                                            readOnly
                                        />
                                    </div>
                                    <div className="h-6 w-px bg-border flex-shrink-0" />
                                    <div className="flex items-center gap-1 px-3 flex-1">
                                        <span className="text-sm text-muted-foreground whitespace-nowrap">To</span>
                                        <Input
                                            type="text"
                                            className="bg-transparent text-sm cursor-pointer w-full !border-0 outline-none h-auto p-0 rounded-none"
                                            value={format(endDate, "MM/dd/yyyy")}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </DateRangePicker>
                            
                            <div className="flex gap-2 items-center flex-1">
                                {/* Search Input - Takes remaining width */}
                                <div className="relative flex-1" ref={searchInputRef}>
                                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                                    <Input
                                        type="text"
                                        placeholder="Search"
                                        className="searchFilter pl-9 w-full"
                                        value={searchValue}
                                        onChange={handleSearchChange}
                                        onFocus={handleSearchFocus}
                                    />
                                    {searchLoading && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-muted-foreground" />}
                                    {showSearchResults && searchDisplay.length > 0 && (
                                        <div className="absolute top-full left-0 right-0 mt-1 w-full bg-popover border rounded-md shadow-lg z-50 max-h-60 overflow-y-auto">
                                            {searchDisplay.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="flex items-center justify-between px-3 py-2 hover:bg-accent cursor-pointer text-sm border-b last:border-b-0"
                                                    onClick={() => handleSearchItemClick(item)}
                                                >
                                                    <span className="font-medium">
                                                        {item.cvalue || ''}
                                                    </span>
                                                    <span className="text-muted-foreground">
                                                        {getTagTypeFullName(item.cname) || 'Unknown'}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Filter Icon Dropdown */}
                                <DropdownMenu>
                                    <DropdownMenuTrigger asChild>
                                        <Button variant="outline" size="icon">
                                            <SlidersHorizontal className="h-4 w-4" />
                                        </Button>
                                    </DropdownMenuTrigger>
                                    <DropdownMenuContent align="end" className="w-48">
                                        <DropdownMenuItem asChild>
                                            <NavLink to="/filter">Create New Filter</NavLink>
                                        </DropdownMenuItem>
                                        {userFilterList != null && userFilterList.length > 0 && (
                                            <>
                                                <DropdownMenuSeparator />
                                                {userFilterList.map((e1) => (
                                                    <DropdownMenuItem key={e1.dashboardId} onClick={() => applyUserFilter(e1)}>
                                                        {e1.filterName}
                                                    </DropdownMenuItem>
                                                ))}
                                            </>
                                        )}
                                    </DropdownMenuContent>
                                </DropdownMenu>
                            </div>
                        </div>
                    </CardContent>
                </Card>

                {/* Filter Tags - Outside Card */}
                {FilterTagList && FilterTagList !== '{}' && FilterTagList !== '' && (() => {
                    try {
                        const filters = JSON.parse(FilterTagList);
                        return Object.keys(filters).length > 0 && (
                            <div className="flex items-start gap-4">
                                {/* Scrollable tags container */}
                                <div className="overflow-x-auto">
                                    <div className="flex items-start gap-4 min-w-min">
                                {Object.keys(filters).map((key) =>
                                    filters[key].map((value, index) => (
                                        <Badge
                                            key={`${key}-${index}`}
                                            variant="outline"
                                            className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-normal leading-none whitespace-nowrap bg-primary/10 text-primary border-primary"
                                        >
                                            {getTagTypeFullName(key)}: {value}
                                            <Button
                                                variant="ghost"
                                                size="icon"
                                                onClick={() => handleRemoveTag(key, value)}
                                                className="h-4 w-4 p-0 hover:bg-transparent hover:text-current [&_svg]:size-2.5"
                                            >
                                                <X />
                                            </Button>
                                        </Badge>
                                    ))
                                )}
                                    </div>
                                </div>
                                {/* Reset button - fixed outside scroll */}
                                <Button
                                    variant="ghost" className="h-auto py-1 px-3 gap-1.5 whitespace-nowrap flex-shrink-0 leading-[1.15] bg-foreground text-card border border-foreground hover:bg-foreground hover:text-card hover:opacity-85"
                                    onClick={handleResetButton}
                                >
                                    Reset
                                </Button>
                            </div>
                        );
                    } catch (error) {
                        return null;
                    }
                })()}

                <div className="grid grid-cols-1 2xl:grid-cols-2 gap-3">
                    {graphData.map((item, index) => (
                        <div key={`graph-widget-${index}`} className="min-h-[400px]">
                            {item.type === "List" && (
                                <ListChartWidget
                                    data={item}
                                    _Index={index}
                                    handlechangea={handlechangea}
                                />
                            )}
                            {item.type === "Column_Pie" && (
                                <ColumnPieChart
                                    data={item}
                                    _Index={index}
                                    handlechangea={handlechangea}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </PagesWrapper>
    );
}

            export default Pharmacies;
